import { render } from "./WarehouseOperationPage.vue?vue&type=template&id=3481aa43&scoped=true"
import script from "./WarehouseOperationPage.vue?vue&type=script&lang=js"
export * from "./WarehouseOperationPage.vue?vue&type=script&lang=js"

import "./WarehouseOperationPage.vue?vue&type=style&index=0&id=3481aa43&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3481aa43"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QBtn});
